
import React from "react";
import IngredientBadge from "./IngredientBadge";

interface SelectedIngredientsProps {
  ingredients: string[];
  onRemove: (ingredient: string) => void;
  title: string;
  variant?: "default" | "secondary" | "destructive";
}

const SelectedIngredients: React.FC<SelectedIngredientsProps> = ({
  ingredients,
  onRemove,
  title,
  variant = "default"
}) => {
  if (ingredients.length === 0) return null;

  return (
    <div>
      <p className="text-sm mb-1">{title}:</p>
      <div className="flex flex-wrap gap-1 mb-2">
        {ingredients.map((ingredient) => (
          <IngredientBadge
            key={ingredient}
            ingredient={ingredient}
            onRemove={onRemove}
            variant={variant}
          />
        ))}
      </div>
    </div>
  );
};

export default SelectedIngredients;
